export const MENU_MODE_CATEGORIES = [
    'restaurante',
    'cafetería',
    'cafeteria',
    'heladería',
    'heladeria',
    'dulcería',
    'dulceria'
];

export const isMenuMode = (category?: string) => {
    if (!category) return false;
    return MENU_MODE_CATEGORIES.some(c => category.toLowerCase().includes(c));
};
